/* Template: Component - Page background
========================================================================== */
template.component.pageBackground = function() {

  $contentHeader = $('.content-header'),
  contentHeaderHeight = $contentHeader.innerHeight() + 40,
  $heroBackground = $('.hero--background');

  if(contentHeaderHeight > 400) {
      $heroBackground.css('height', contentHeaderHeight);
  }
};
